/**
 * Default app backdrop for the imageless "Default" theme — a Framer-style dark
 * off-charcoal. Kept as Tailwind layers so the visual can be art-directed without
 * growing global CSS.
 */
export function DefaultBackdrop() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-0 hidden overflow-hidden bg-[#111114] [html[data-skin='framer']_&]:block"
    >
      {/* Off-charcoal base with a subtle soft light at the top center (Framer-like). */}
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#16161a_0%,#0e0e11_55%,#0b0b0e_100%)]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120vw] h-[80vh] bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.05)_0%,rgba(0,0,0,0)_70%)]" />
    </div>
  );
}
